export const bytesToMB = (bytes: number, fractionDigits = 0) => {
  const mb = bytes / (1024 * 1024); // 1MB = 1024 * 1024 bytes
  return mb.toFixed(fractionDigits); // 소수점 자릿수
};
